module.exports = __webpack_public_path__ + "img/vr-bg.f242b8f0.jpg";